let counterElement = document.getElementById('counter');
if(counterElement){
  let startTimestampInput = counterElement.getAttribute('data-start-timestamp');
  let endTimestampInput = counterElement.getAttribute('data-end-timestamp');
  let startTimestamp = startTimestampInput * 1000;
  let endTimestamp = endTimestampInput * 1000;
  let currentTimestamp = Math.floor(Date.now());
  if(currentTimestamp && startTimestamp && endTimestamp){
    if (currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp) {
      let countdownDate = endTimestamp;
    
      let x = setInterval(function() {
        let now = new Date().getTime();
        let distance = countdownDate - now;
    
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("countdown").innerHTML = "EXPIRED";
        } else {
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);
          document.querySelector(".counter-block-days p.counter-days-number").innerHTML = days;
          document.querySelector(".counter-block-hours p.counter-hours-number").innerHTML = hours;
          document.querySelector(".counter-block-minutes p.counter-minutes-number").innerHTML = minutes;
          document.querySelector(".counter-block-seconds p.counter-seconds-number").innerHTML = seconds;
        }
      }, 1000);
    } else {
      document.getElementById("countdown").style.display = "none";
    }
  }
}